import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as categories from '../categories'

import type { TypeParams } from './types'

const ATTRIBUTES: readonly ec.models.Attribute<TypeParams>[] = [
  ec.models.Attribute.fromKey('code', { name: 'code' }),
  ec.models.Attribute.fromKey('name', { name: 'name' }),
  ec.models.Attribute.fromKey('isUtilityRelated', { name: 'isUtilityRelated' }),
]

@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => {
      const idcCategoryEc = ec.Collection.instances.get<categories.TypeParams>(
        ec.Name.Predefined.IdcFunctionCategory,
      ).collection

      return context
        ? idcCategoryEc.plugins.dataOperationPlugin.feature.actions.list
            .from('Subcategories.Api.list')
            .execute()
            .asObservable.pipe(
              rxjs.map(result => _categoriesToSubcategories(result.entities)),
            )
        : rxjs.of([])
    },
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of(ATTRIBUTES)
}

/** TODO: documentation */
function _categoriesToSubcategories(
  _categories: readonly ents.extra.common.FaFunction.Category.WithSubcategories[],
): ents.extra.common.FaFunction.Subcategory.WithCategoryId[] {
  return Array.from(
    new Set(
      _categories.flatMap(
        category =>
          category.subcategories?.map(subcategory => ({
            ...subcategory,
            categoryId: category.id,
          })) ?? [],
      ),
    ),
  )
}
